'use client'

import type { ILoginEmail, ILoginNamekey } from 'msgdsk-types'
import type { VisitorUser } from './model'

async function enter(provider: 'credentials' | 'email_pin', details: ILoginNamekey | ILoginEmail): Promise<VisitorUser | null> {
  const { getSession, signIn } = await import('next-auth/react')
  const response = await signIn(provider, { redirect: false, ...details })
  if (!response?.ok || response.error) return null
  const session = await getSession()
  return session?.user ?? null
}

function enterWithMessage(details: ILoginNamekey): Promise<VisitorUser | null> {
  return enter('credentials', details)
}

function enterWithEmail(details: ILoginEmail): Promise<VisitorUser | null> {
  return enter('email_pin', details)
}

async function leave(options: { callbackUrl?: string; redirect?: boolean } = {}): Promise<void> {
  const { signOut } = await import('next-auth/react')
  await signOut({
    redirect: options.redirect ?? true,
    callbackUrl: options.callbackUrl,
  })
}

export const visitorGateway = Object.freeze({
  enterWithMessage,
  enterWithEmail,
  leave,
})
